/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiGiftItem } from './GiftItem';

export interface GiftReceiptRequest {

    /**
     * If present, indicates an error. Can be 'invalid', 'failure', or 'contact-support'.
     */
    error?: string;

    /**
     * Order ID to provide to the purchaser
     */
    uuid?: string;

    /**
     * Date of the order
     */
    date?: string;

    /**
     * Payment source used in the purchase
     */
    payment_source?: string;

    /**
     * Purchaser's email address
     */
    purchaser_email?: string;

    /**
     * Purchaser's name
     */
    purchaser_name?: string;

    /**
     * Amount charged to card
     */
    total_amount?: string;

    gift_items?: ApiGiftItem[];

}

@Model('GiftReceipt')
export class ApiGiftReceipt extends BaseModel implements GiftReceiptRequest {

    /**
     * If present, indicates an error. Can be 'invalid', 'failure', or 'contact-support'.
     */
    
    
    error: string;

    /**
     * Order ID to provide to the purchaser
     */
    
    
    uuid: string;

    /**
     * Date of the order
     */
    
    
    date: string;

    /**
     * Payment source used in the purchase
     */
    
    
    payment_source: string;

    /**
     * Purchaser's email address
     */
    
    
    purchaser_email: string;

    /**
     * Purchaser's name
     */
    
    
    purchaser_name: string;

    /**
     * Amount charged to card
     */
    
    
    total_amount: string;

    @Type('ApiGiftItem')
    @Expand()
    gift_items: ApiGiftItem[];

}
